// NATIVE 


// INSTALLED 
import { Alert, Button, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Inventory2Icon from '@mui/icons-material/Inventory2';


// CUSTOM 
import { storeItemsStore } from 'store/size_items';
import { EditDinamicDotacion } from './dinamic-dotacion/EditDinamicDotacion';
import { useEffect } from 'react';
import { useFormikContext } from 'formik';
// import { DinamicDotacion } from './dinamic-dotacion/DinamicDotacion';





export const EditDotacion = (props:any) => {


    // DISPATCH  
    const dispatch = useDispatch();
  
    // REDUX 
    const { sizeItemsDotacion }: any = useSelector((state: any) => state.sizeItems);

    const  { employee }  = useSelector( (state:any) => state.employee );

    const formikProps:any = useFormikContext();

    useEffect(() => {
    
        if (employee &&  Object.keys(employee).length > 0) {
            setEmployeeData(employee);
        }
    }, [employee]);




    const dotacionList = [
      { label: 'bata mantenimiento', value: 'bata_mantenimiento' },
      { label: 'blazer', value: 'blazer' },
      { label: 'blusa', value: 'blusa' },
      { label: 'botas', value: 'botas' },
      { label: 'bufanda', value: 'bufanda' },
      { label: 'camisa', value: 'camisa' },
      { label: 'chaqueta impermeable', value: 'chaqueta_impermeable' },
      { label: 'corbata', value: 'corbata' },
      { label: 'delantal', value: 'delantal' },
      { label: 'falda short', value: 'falda_short' },
      { label: 'grillo', value: 'grillo' },
      { label: 'jean', value: 'jean' },
      { label: 'pantalon', value: 'pantalon' },
      { label: 'zapatos', value: 'zapatos' },
    ];


    const setEmployeeData = async(employee:any) => { 
        if (formikProps.values.is_initialized_dotacion) return;
        formikProps.setFieldValue('is_initialized_dotacion', true);
      
  
        if ( employee && employee.dotaciones && employee.dotaciones.length > 0)  {

                const copyEmployee = JSON.parse(JSON.stringify(employee));
             
                copyEmployee.dotaciones = copyEmployee.dotaciones.map((dotacion: any) => {
                  const dotacionItem = dotacionList.find(d => d.value === dotacion.item);
                  return {
                    ...dotacion,
                    nombre: dotacionItem ? dotacionItem : dotacion.item,
                    action: 'editar',
                    dotacionId: dotacion.id
                  };
                });
 
              
                // dentro de employee dotaciones vielne un array de objetos dentro hay un elemento que se llama item ese item es el value del array dotacionlist quiero que tomes el objeto donde coincida y lo pongas en el item lave que esta dentro del employee.dotaciones sin modificar los edemas elementos solo ese 
  
              formikProps.setFieldValue('items', copyEmployee.dotaciones); // 🔹 Actualiza Formik
              await dispatch(storeItemsStore(copyEmployee.dotaciones)); // 🔹 Opcional: actualiza Redux si necesitas
        }
  
    }
    

    const addItem = async() => {
      const newItem = {
        nombre: null,
        talla: '',
        cantidad: '',
        color: '',
        descripcion: '',
        action: 'crear'
      };
      const currentItems = Array.isArray(formikProps.values.items) ? [...formikProps.values.items] : [];
      const updatedItems = [...currentItems, newItem];
      formikProps.setFieldValue('items', updatedItems);
      await dispatch(storeItemsStore(updatedItems));
    }



  return (
    <div>


      <Grid size={{ xs: 3 }}> 
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddCircleIcon />}
          endIcon={<Inventory2Icon />}
          onClick={addItem} // esta es tu función para agregar un beneficiario
          sx={{ mt: 2, borderRadius: 2 }}
        >
          Agregar Item
        </Button>
      </Grid>


      <EditDinamicDotacion children={sizeItemsDotacion} />  


    </div>
  )
}
